import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getLiquidityPool } from "../../utils/contractHelpers";
import { LUCKIFY_CONTRACT_ADDRESS } from "../../utils/Enviroment";

export const RemoveLiquidity = () => {
  const web3 = useWeb3();
  const stakingAddress = LUCKIFY_CONTRACT_ADDRESS;
  const contract = getLiquidityPool(stakingAddress, web3);
  const { account } = useWeb3React();

  const RemoveLiquidityHook = useCallback(
    async (amount) => {
      const Amount = web3.utils.toWei(amount?.toString(), "ether");
      let gasPrice = await web3.eth.getGasPrice();
      // gasPrice = parseInt(gasPrice) + 1000000000;
      try {
        // const gas = await contract?.methods
        //   ?.withdraw(Amount)
        //   ?.estimateGas({ from: account });
        // gas = parseInt(gas) + 600000;
        // console.log(gas,'gasgasgas');
        const gas = 400000;

        const withdraw = await contract?.methods
          ?.withdraw(Amount)
          ?.send({ from: account, gasPrice: gasPrice, gas });
        return withdraw;
      } catch (e) {
        throw e;
      }
    },
    [contract, web3, account]
  );
  return { RemoveLiquidityHook: RemoveLiquidityHook };
};

export default RemoveLiquidity;
